import axios from 'axios'
import apiStatusStates from '@/utils/store/apiStatusStates'
import apiStatusMutations from '@/utils/store/apiStatusMutations'
import router from '@/router'

const BASE_URL = process.env.API_URL + '/admin'

export default class {
  constructor (endpoint) {
    this.state = {
      ...apiStatusStates,
      endpoint: BASE_URL + `/${endpoint}`,
      data: null
    }
    this.getters = {
      apiStatus: state => state.apiStatus,
      apiLoading: state => state.apiStatus === 'loading',
      endpoint: state => state.endpoint,
      all: state => state.data
    }
    this.mutations = {
      ...apiStatusMutations,
      set_data (state, data) {
        state.data = data
      },
      empty (state, data) {
        state.data = null
      }
    }
    this.actions = {
      all ({ commit, dispatch, getters }) {
        return dispatch('request', {
          settings: {
            url: getters.endpoint + 's',
            method: 'GET'
          },
          save: true,
          refresh: false
        })
      },

      get ({ commit, dispatch, getters }, id) {
        return dispatch('request', {
          settings: {
            url: getters.endpoint + `/` + id,
            method: 'GET'
          },
          save: false,
          refresh: false
        })
      },

      post ({ commit, dispatch, getters }, data) {
        return dispatch('request', {
          settings: {
            url: getters.endpoint,
            data: data,
            method: 'POST'
          },
          save: true,
          refresh: false
        })
      },

      patch ({ commit, dispatch, getters }, data) {
        return dispatch('request', {
          settings: {
            url: getters.endpoint + `/` + data.get('id'),
            data: data,
            method: 'POST'
          },
          save: false,
          refresh: false
        })
      },

      delete ({ commit, dispatch, getters }, id) {
        return dispatch('request', {
          settings: {
            url: getters.endpoint + `/` + id,
            method: 'DELETE'
          },
          save: false,
          refresh: true
        })
      },

      request ({ commit, dispatch, getters }, data) {
        return new Promise((resolve, reject) => {
          commit('api_request')
          axios(data.settings)
            .then(resp => {
              commit('api_success')
              if (data.save) {
                commit('set_data', resp.data.data)
              }
              if (data.refresh) {
                commit('empty')
              }
              resolve(resp.data)
            })
            .catch(err => {
              commit('api_error')
              console.log(err)
              if (err.response.status === 401) {
                dispatch('catchHandler', null, {root: true})
                router.push('/login')
              }
              reject(err)
            })
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/base.module.js